<template>
  <div class="row">
    <div class="text-center text-black">ما را در شبکه های اجتماعی دنبال کنید.</div>
    <div v-for="item in items" :key="item.href" class="icon-parent">
      <a :href="item.href" target="_blank">
        <img
          class="icon"
          :src="require(`../assets/${item.icon}.png`)"
          target="_blank"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          href: "https://gap.im/Howzehkhnews",
          icon: "gap_icon",
        },
        {
          href: "https://ble.im/howzehkhnews",
          icon: "bale_icon",
        },
        {
          href: "https://sapp.ir/howzehkhnews",
          icon: "mobi_icon",
        },
        {
          href: "https://eitaa.com/howzehkhnews",
          icon: "eita_icon",
        },
        {
          href: "https://www.instagram.com/howzehkhnews",
          icon: "instagram_icon",
        },
      ],
    };
  },
};
</script>
<style scoped>
.icon {
  width: 100%;
  height: 100%;
}
.icon-parent {
  float: right;
  width: 20%;
  padding: 15px;
}

</style>
